import React from 'react';
import { Link } from 'react-router-dom';

const states = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
  'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
  'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
  'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
  'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

export default function StateGrid() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {states.map((state) => (
        <Link
          key={state}
          to={`/reiki/${state.toLowerCase().replace(/\s+/g, '-')}`}
          className="bg-white dark:bg-dark-secondary p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 text-center"
        >
          <span className="text-gray-900 dark:text-gray-100 font-medium">{state}</span>
        </Link>
      ))}
    </div>
  );
}